import { BaseModel } from "./BaseModel";

export class OrgColumnStats extends BaseModel {
  schema = "/orgColumnStats";
  constructor(params) {
    return super(params, "/orgColumnStats");
  }
}
